import type { Route } from '@angular/router';
import { eventCategoryRoutes } from './category/event-category.routes';
import {
  sequentialDeactivateGuards,
  hasStringPathParamCanActivateGuard,
} from '@pct-ng/core/router';
import { showToasterDeactivateGuard } from '@pct-ng/form';
import { dirtyCheckCanDeactivateGuard } from '@pct-ng/feature-dirty-check';

export const eventRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/event-list.component').then(({ EventListComponent }) => EventListComponent),
    pathMatch: 'full',
  },
  {
    path: 'category',
    children: eventCategoryRoutes,
    title: 'PAGES.EVENT.CATEGORY.BREADCRUMB.LIST',
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./details/event-details.component').then(
        ({ EventDetailsComponent }) => EventDetailsComponent,
      ),
    title: 'PAGES.EVENT.BREADCRUMB.NEW',
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.EVENT.SINGULAR'),
      ]),
    ],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./details/event-details.component').then(
        ({ EventDetailsComponent }) => EventDetailsComponent,
      ),
    title: 'PAGES.EVENT.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.EVENT.SINGULAR'),
      ]),
    ],
  },
];
